export default "__VITE_ASSET__73fdc119__"